import React, { Component } from 'react';

export class ImageThumbnail extends Component {
  constructor(props){
    super(props);
    this.state = {
      orientation: 'landscape',
    }
  }

  checkOrientation = (ev) => {
    this.setState({
      orientation: (this.refs.image.naturalWidth > this.refs.image.naturalHeight ? 'landscape' : 'portrait'),
    });
  }

  render() {
    return (
      <div className="content-container content-container--imageThumbnail">
        <div className={`content-container-background imageThumbnail-download orientation-${this.state.orientation}`} data-url={this.props.image}>
          <img ref="image" onLoad={(ev) => this.checkOrientation(ev)} src={this.props.image} alt={"grpimg"}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/ImageThumbnail.js